export default "__VITE_ASSET__DLajnVG$__"